/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type WorkspaceArchiveRequest = {
  paths?: Array<string> | undefined;
};

/** @internal */
export const WorkspaceArchiveRequest$inboundSchema: z.ZodType<
  WorkspaceArchiveRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  paths: z.array(z.string()).optional(),
});
/** @internal */
export type WorkspaceArchiveRequest$Outbound = {
  paths?: Array<string> | undefined;
};

/** @internal */
export const WorkspaceArchiveRequest$outboundSchema: z.ZodType<
  WorkspaceArchiveRequest$Outbound,
  z.ZodTypeDef,
  WorkspaceArchiveRequest
> = z.object({
  paths: z.array(z.string()).optional(),
});

export function workspaceArchiveRequestToJSON(
  workspaceArchiveRequest: WorkspaceArchiveRequest,
): string {
  return JSON.stringify(
    WorkspaceArchiveRequest$outboundSchema.parse(workspaceArchiveRequest),
  );
}
export function workspaceArchiveRequestFromJSON(
  jsonString: string,
): SafeParseResult<WorkspaceArchiveRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => WorkspaceArchiveRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'WorkspaceArchiveRequest' from JSON`,
  );
}
